import { Box } from '@mui/material'
import dayjs, { Dayjs } from 'dayjs'
import { FC, useState } from 'react'

import SplitFlapTimer from '@/common/components/SplitFlapTimer'
import useInterval from '@/common/hooks/useInterval'
import { useTranslation } from 'react-i18next'

type TimerParams = { endDate: Dayjs }

const Timer: FC<TimerParams> = ({ endDate }) => {
  const [timeRemaining, setTimeRemaining] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  })
  const { t } = useTranslation()
  useInterval(() => {
    const remainingMs = endDate.diff(dayjs())
    const remainingSeconds = Math.floor(remainingMs / 1000)
    const newTime = convertToTime(remainingSeconds > 0 ? remainingSeconds : 0)
    setTimeRemaining(newTime)
  }, 1000)

  return (
    <Box display="flex" justifyContent="center" paddingTop={4} gap={4}>
      <SplitFlapTimer value={timeRemaining.days} label={t('campaignDashboard.timeFrame.timer.days')} />
      <SplitFlapTimer value={timeRemaining.hours} label={t('campaignDashboard.timeFrame.timer.hours')} />
      <SplitFlapTimer value={timeRemaining.minutes} label={t('campaignDashboard.timeFrame.timer.minutes')} />
      <SplitFlapTimer value={timeRemaining.seconds} label={t('campaignDashboard.timeFrame.timer.seconds')} />
    </Box>
  )
}

const convertToTime = (secondsRemaining: number) => {
  const days = Math.floor(secondsRemaining / (3600 * 24))
  const hours = Math.floor((secondsRemaining % (3600 * 24)) / 3600)
  const minutes = Math.floor((secondsRemaining % 3600) / 60)
  const seconds = Math.floor(secondsRemaining % 60)
  return { days, hours, minutes, seconds }
}

export default Timer
